import useSWRMutation from "swr/mutation";
import type { SWRMutationConfiguration } from "swr/mutation";
import { AppError } from "@/models/appError";
import { IContestLegalAgreement } from "@/models/contestDetail";
import { MutationRepository } from "@/repositories/mutationRepository";

const KEY = "MutationService/LegalAgreement";

export type SWRError = AppError;
type SWRKey = ["MutationService/LegalAgreement"] | undefined;
type Arg = {
  legalAgreement: IContestLegalAgreement;
};
type Data = void;

const sendRequest = async ({ legalAgreement }: Arg) => {
  const mutationRepository = new MutationRepository();
  return mutationRepository.acceptLegalAgreement(
    legalAgreement.latestVersion.id,
  );
};

export const useMutateLegalAgreement = (
  options?: SWRMutationConfiguration<Data, SWRError, SWRKey, Arg>,
) => {
  return useSWRMutation<Data, SWRError, SWRKey, Arg>(
    [KEY],
    async (_, { arg }) => sendRequest(arg),
    options,
  );
};
